define('areas/home/model/panels',["require", "exports"], function (require, exports) {
    "use strict";
    (function (PanelType) {
        PanelType[PanelType["ComposedView"] = 1] = "ComposedView";
        PanelType[PanelType["Module"] = 2] = "Module";
    })(exports.PanelType || (exports.PanelType = {}));
    var PanelType = exports.PanelType;
    var ShellPanel = (function () {
        function ShellPanel(type, path, visible) {
            if (visible === void 0) { visible = true; }
            this.type = type;
            this.path = path;
            this.visible = visible;
            ko.track(this, ["type", "path", "visible"]);
        }
        return ShellPanel;
    }());
    exports.ShellPanel = ShellPanel;
});

